<template>
  <el-form
    ref="form"
    :model="formData"
    :rules="rules">
    <section class="new-industry-form">
      <div class="left">
        <span class="label">Basic Information</span>
        <div class="form-item">
          <span>Insured Name</span>
          <v-input v-model="formData.isrd_nm" />
        </div>
        <!-- <div class="form-item">
          <span>Business Hour</span>
          <v-input v-model="formData.business_hour" />
        </div> -->
        <div class="form-item">
          <span>Any plate glass in the premises?</span>
          <v-radio-group
            v-model="formData.glass_premises_ind"
            :border="true"
            :list="yesNoOptions" />
        </div>
        <div
          v-if="formData.glass_premises_ind == 1"
          class="form-item">
          <span>What is the value of plate glass?</span>
          <v-input
            v-model="formData.value_of_glass"
            prepend="HK$"
            type="number"
            :min="0"
            :int="true"
            :keyNumber="true" />
        </div>

        <span class="label">Claim History </span>
        <div class="form-item">
          <span>Any claim history in the past 3 years?</span>
          <v-radio-group
            v-model="formData.claim_history_ind"
            :border="true"
            :list="yesNoOptions" />
        </div>

        <span class="label">Upload Document</span>
        <div class="form-item">
          <span>Business Registration Certificate</span>
          <section v-show="formData.business_file && formData.business_file.id">
            <file-container
              :fileData="formData.business_file"
              :edit="true"
              titleName= "Business Registration Certificate"
              @uploadSuccess="handlerUploadSuccess"
              @delete="deleteBusinessFile" />
          </section>
          <v-upload
            @uploadSuccess="handlerUploadSuccess" />
        </div>

        <span class="label">Other insurance you may need</span>
        <v-checkbox
          v-model="formData.need_group_personal_ind"
          :isBoolean="false">Group Personal Accident Insurance</v-checkbox>
        <v-checkbox
          v-model="formData.need_group_medical_ind"
          :isBoolean="false">Group Medical Insurance</v-checkbox>
        <v-checkbox
          v-model="formData.need_group_travel_ind"
          :isBoolean="false">Group Travel</v-checkbox>
        <v-checkbox
          v-model="formData.need_money_ind"
          :isBoolean="false">Money Insurance</v-checkbox>
        <v-checkbox
          v-model="formData.need_fidelity_ind"
          :isBoolean="false">Fidelity Guarantee Insurance</v-checkbox>


      </div>
      <div class="middle">
        <v-checkbox
          v-model="formData.contents_ind"
          :isBoolean="false">Contents</v-checkbox>
        <p class="tips">To indemnify the Insured against accidental loss or damage to the Contents including but not limited to Stock, Machinery, Furniture, fixtures, fittings, occupier’s improvements, air-conditioning system, office equipment, computer equipment, decorations, samples.</p>
        <template v-if="formData.contents_ind">
          <div class="form-item">
            <span>Sum Insured of Contents (Other than Stocks) </span>
            <v-input
              v-model="formData.total_contents"
              prepend="HK$" />
          </div>

          <div class="form-item">
            <span>What kind of stock?</span>
            <v-input v-model="formData.kind_of_stock" />
          </div>
          <div class="form-item">
            <span>Sum Insured of Stocks</span>
            <v-input
              v-model="formData.total_stocks"
              prepend="HK$"
              type="number"
              :min="0"
              :int="true"
              :keyNumber="true" />
          </div>
          <div class="form-item">
            <span>Is stock stored in locked room?</span>
            <v-radio-group
              v-model="formData.stock_stored_locked_ind"
              :border="true"
              :list="yesNoOptions" />
          </div>
          <!-- <div class="form-item">
            <span>Max. value per piece/carton of stock?</span>
            <v-input
              v-model="formData.value_stock_stored_locked"
              prepend="HKD"
              type="number"
              :min="0"
              :int="true"
              :keyNumber="true" />
          </div> -->
          <div class="form-item">
            <span>Any burglar alarm system?</span>
            <v-radio-group
              v-model="formData.burglar_system_ind"
              :border="true"
              :list="yesNoOptions" />
          </div>
          <div class="form-item">
            <span>Any Fire extinguisher?</span>
            <v-radio-group
              v-model="formData.fire_system_ind"
              :border="true"
              :list="yesNoOptions" />
          </div>

        </template>

        <v-checkbox
          v-model="formData.public_liability_ind"
          :isBoolean="false">Public Liability</v-checkbox>
        <p class="tips">To indemnify the Insured against all sums which the Insured become legally liable to pay as damages consequent upon accidental injury to Third Parties and/or the property of Third Parties arising out of any of the Insured's business.</p>
        <template v-if="formData.public_liability_ind">
          <div class="form-item">
            <span>Any neon signboard outside premises? Hang-up/ placing outside the shop? </span>
            <v-radio-group
              v-model="formData.signboard_outside_ind"
              :border="true"
              :list="yesNoOptions" />
          </div>
          <div
            v-if="formData.signboard_outside_ind == 1"
            class="form-item">
            <span>What's the height from ground level?</span>
            <v-input
              v-model="formData.high_from_ground_level" />
          </div>
          <div
            v-if="formData.signboard_outside_ind == 1"
            class="form-item">
            <span>What’s the size?</span>
            <v-input
              v-model="formData.size_of_signboard" />
          </div>

        </template>
      </div>
      <div class="right">
        <v-checkbox
          v-model="formData.employee_ind"
          :isBoolean="false">Employee’s Compensation</v-checkbox>
        <p class="tips">To indemnify the Insured in respect of all sums up to the maximum limit as stated in the policy which the Insured shall be legally liable to pay as compensation for personal injuries by accident or disease sustained by employees of the Insured and arising out of and in the course of employment.</p>
        <template v-if="formData.employee_ind">
          <div class="form-item">
            <span>Total Number of Employee(s)</span>
            <v-input v-model="formData.total_no_of_employee" />
          </div>
          <!-- <div class="form-item">
            <span>Any Manual Work ?</span>
            <v-radio-group
              v-model="formData.manual_work_ind"
              :border="true"
              :list="yesNoOptions" />
          </div> -->
          <div class="form-item">
            <span>Any staff needs to station overseas (include staying in China or Macau)? </span>
            <v-radio-group
              v-model="formData.station_overseas_ind"
              :border="true"
              :list="yesNoOptions" />
          </div>

          <div
            v-for="(item, index) in formData.occ_information_list"
            :key="index"
            class="occ-item">
            <div class="flex-sb occ-item-header">
              <span class="occ-item-label">Occupation {{ index+1 }}</span>
              <span
                v-if="formData.occ_information_list.length !== 1"
                class="delete"
                @click="onDeleteOcc(index)">Delete</span>
            </div>
            <div class="tr">
              <div class="form-item form-half">
                <span>Occupation / Position</span>
                <v-input v-model="item.occ_position" />
              </div>
              <div class="form-item form-half">
                <span>Number of Employee(s)</span>
                <v-input v-model="item.no_of_employee" />
              </div>
            </div>
            <div class="tr">
              <div class="form-item form-half">
                <span>Estimate Annual Salary?</span>
                <v-input
                  v-model="item.annual_salary"
                  prepend="HK$"
                  type="number"
                  :min="0"
                  :int="true"
                  :keyNumber="true" />
              </div>
              <div class="form-item form-half">
                <span>Nature</span>
                <v-select
                  v-model="item.nature"
                  :list="globalOptions.nature" />
              </div>
            </div>
          </div>
          <v-button
            type="primary"
            plain
            class="width-fill"
            icon="plus"
            :disabled="disabledOccAdd"
            @click="onAddOcc">Add</v-button>

        </template>
      </div>
    </section>
  </el-form>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
export default {
  name: 'NewRetailForm',
  mixins: [MixinOptions, MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const occObj = {
      occ_position: '',
      no_of_employee: '',
      annual_salary: '',
      nature: ''
    }
    return {
      occObj,
      formData: {
        isrd_nm: '',
        // business_hour: '',
        glass_premises_ind: '',
        value_of_glass: '',
        claim_history_ind: '',
        need_group_personal_ind: 0,
        need_group_medical_ind: 0,
        need_group_travel_ind: 0,
        need_money_ind: 0,
        need_fidelity_ind: 0,
        contents_ind: 0,
        total_contents: '',
        kind_of_stock: '',
        total_stocks: '',
        stock_stored_locked_ind: '',
        // value_stock_stored_locked: '',
        burglar_system_ind: '',
        fire_system_ind: '',
        public_liability_ind: 0,
        signboard_outside_ind: '',
        high_from_ground_level: '',
        size_of_signboard: '',
        employee_ind: 0,
        total_no_of_employee: '',
        // manual_work_ind: '',
        station_overseas_ind: '',
        business_file: {
          id: '',
          name: '',
          thumb_name: '',
          url: '',
          thumb_url: ''
        },
        occ_information_list: [{
          ...occObj
        }]
      }
    }
  },
  computed: {
    disabledOccAdd() {
      return this.formData.occ_information_list.length >= 20
    }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(data) {
        Object.keys(data).some(key => {
          if(key in this.formData) {
            this.formData[key] = data[key]
          }
        })
      }
    }
  },
  methods: {
    submitForm() {
      this.$refs['form'].validate(valid => {
        if(valid) {
          this.$emit('getFormData', this.formData)
        }
      })
    },
    onDeleteOcc(index) {
      this.formData.occ_information_list.splice(index, 1)
    },
    onAddOcc() {
      if(this.disabledOccAdd) {
        return
      }
      this.formData.occ_information_list.push({
        ...this.occObj
      })
    },
    deleteBusinessFile() {
      this.formData.business_file = {}
    },
    handlerUploadSuccess({ data }) {
      this.formData.business_file = data
    }
  }
}
</script>
<style lang="scss" scoped>
@import './common.scss'
</style>